import { FormattedMessage, FormattedDate } from 'react-intl';
import { Box, Grid } from 'components/ui';
import { TitleTypography, SubtitleTypography } from 'components/styles_components/typography';
import { userLabel } from 'utils/user';

const Welcome = ({
  user,
  placesTotal = 0,
  inspectionSubjectsTotal = 0,
  inspectionsTotal = 0,
  children,
}) => {
  const userName = userLabel(user, '');

  return (
    <Grid container alignItems="center">
      <Grid size={{ xs: 12, md: 6 }}>
        <TitleTypography variant="h1">
          <FormattedMessage id="dashboard.welcome" values={{ name: userName }} />
        </TitleTypography>
        <SubtitleTypography>
          <Box component="span" sx={{ '&::first-letter': { textTransform: 'uppercase' } }}>
            <FormattedDate
              value={new Date()}
              weekday="long"
              day="numeric"
              month="long"
              year="numeric"
            />
          </Box>
          {' · '}
          <FormattedMessage
            id="dashboard.places_count"
            values={{ count: placesTotal }} />
          {' · '}
          <FormattedMessage
            id="dashboard.inspection_subjects_count"
            values={{ count: inspectionSubjectsTotal }} />
          {' · '}
          <FormattedMessage
            id="dashboard.inspections_count"
            values={{ count: inspectionsTotal }} />
        </SubtitleTypography>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 2 }} justifyContent="right">
        {children}
      </Grid>
    </Grid>
  );
};

export default Welcome;
